import styled from 'styled-components'
import { ButtonComponent } from 'Pages/landings/newLandings/common/components'
import {
	media,
	Breakpoints,
	WrapperBlock,
	themeObject,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)`
	padding-top: 16px;
	padding-bottom: 16px;
	display: flex;
	justify-content: center;
	${media(
		'padding-top: 12px;	padding-bottom: 12px; justify-content: space-between;',
		Breakpoints.ms
	)};
`
export const Button = styled(ButtonComponent)`
	display: none;
	${media('display: block;', Breakpoints.ms)}
`

export const FixedWrapper = styled.div`
	position: fixed;
	top: 0;
	width: 100%;
	display: flex;
	justify-content: center;
	background-color: ${themeObject.colors.base.white};
	z-index: 1;
	border-bottom: 1px solid ${themeObject.colors.grey[200]};
`
